import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Banner = () => {
  return (
    <div className="banner-section text-white py-5">
      <Container className="py-5">
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <h1 className="display-4 fw-bold mb-4">
              <span className="d-block">Jusqu'à 30% d'economie sur vos intrants</span>
      
            </h1>
            {/*
            <div className="d-inline-block bg-white text-dark p-3 rounded mb-4">
              <p className="mb-0 fs-5">
                <strong>Obtenez votre devis personnalisé en moins de 24 heures</strong>
              </p>
            </div>
            */}
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <Button 
                as={Link} 
                to="/devis-gratuit" 
                variant="success" 
                size="lg" 
                className="rounded-pill px-4"
              >
                <i className="fas fa-calculator me-2"></i>Devis gratuit immédiat
              </Button>
              
              <Button 
                variant="outline-light" 
                size="lg" 
                className="rounded-pill px-4"
                as={Link}
                to="/demo"
              >
                <i className="fas fa-play-circle me-2"></i> Demo offerte
              </Button>
            </div>
            
            <div className="mt-4">
              <p className="small mb-0">
                <i className="fas fa-check-circle text-success me-2"></i>
                Sans engagement • 100% personnalisé • Résultats en 24h
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;